<div class="card">
    <div class="font-semibold text-xl mb-4">Game Templates</div>

    @if (templatesService.error()) {
    <p-message
        severity="error"
        [text]="templatesService.error()!"
        styleClass="mb-3"
    />
    }

    <p-table
        [value]="filteredTemplates()"
        [loading]="templatesService.loading()"
        dataKey="Template.Id"
        [rowTrackBy]="trackById"
        [rows]="10"
        [paginator]="true"
        [showGridlines]="true"
        responsiveLayout="scroll"
    >
        <ng-template #caption>
            <div class="flex items-center justify-between gap-3 flex-wrap">
                <div class="flex items-center gap-2">
                    @if (canManage()) {
                    <p-button
                        label="Add template"
                        icon="pi pi-plus"
                        (onClick)="openCreate()"
                    />
                    }
                    <p-button
                        label="Refresh"
                        icon="pi pi-refresh"
                        severity="secondary"
                        outlined
                        [loading]="templatesService.loading()"
                        (onClick)="refresh()"
                    />
                </div>
                <p-iconfield class="ml-auto">
                    <p-inputicon styleClass="pi pi-search" />
                    <input
                        pInputText
                        type="text"
                        placeholder="Search templates…"
                        [ngModel]="searchTerm()"
                        (ngModelChange)="searchTerm.set($event ?? '')"
                    />
                </p-iconfield>
            </div>
        </ng-template>
        <ng-template #header>
            <tr>
                <th style="width: 5.5rem"></th>
                <th pSortableColumn="Template.Title">
                    Title <p-sortIcon field="Template.Title" />
                </th>
                <th pSortableColumn="Template.GameKind.Name">
                    Game kind <p-sortIcon field="Template.GameKind.Name" />
                </th>
                <th pSortableColumn="Template.GameKind.GameMode">
                    Mode <p-sortIcon field="Template.GameKind.GameMode" />
                </th>
                <th pSortableColumn="Template.GameKind.WinMode">
                    Win mode <p-sortIcon field="Template.GameKind.WinMode" />
                </th>
                <th pSortableColumn="Template.IsActive">
                    Status <p-sortIcon field="Template.IsActive" />
                </th>
                <th pSortableColumn="Template.IsFeatured">
                    Featured <p-sortIcon field="Template.IsFeatured" />
                </th>
                <th pSortableColumn="Template.MinEntryFee">
                    Min entry fee <p-sortIcon field="Template.MinEntryFee" />
                </th>
                <th style="width: 9rem">Actions</th>
            </tr>
        </ng-template>
        <ng-template #body let-item>
            <tr>
                <td>
                    @if (item.Template.IconUrl) {
                    <img
                        [src]="resolveGameContentUrl(item.Template.IconUrl)"
                        [alt]="item.Template.Title"
                        class="w-16 h-16 rounded object-cover"
                    />
                    } @else {
                    <div
                        class="w-16 h-16 rounded bg-surface-100 dark:bg-surface-800 flex items-center justify-center"
                    >
                        <i class="pi pi-image text-muted-color text-xl"></i>
                    </div>
                    }
                </td>
                <td>
                    <div class="flex flex-col">
                        <span class="font-medium"
                            >{{ item.Template.Title }}</span
                        >
                        @if (item.Template.Description) {
                        <span
                            class="text-xs text-muted-color whitespace-pre-line break-words"
                            >{{ item.Template.Description }}</span
                        >
                        }
                    </div>
                </td>
                <td>
                    {{ item.Template.GameKind?.Name ?? item.Template.GameKindId
                    }}
                </td>
                <td>{{ gameModeLabel(item.Template.GameKind?.GameMode) }}</td>
                <td>{{ winModeLabel(item.Template.GameKind?.WinMode) }}</td>
                <td>
                    @if (item.Template.IsActive) {
                    <p-tag value="Active" severity="success" />
                    } @else {
                    <p-tag value="Inactive" severity="secondary" />
                    }
                </td>
                <td>
                    @if (item.Template.IsFeatured) {
                    <i
                        class="pi pi-star-fill text-yellow-500"
                        pTooltip="Featured"
                    ></i>
                    } @else {
                    <i class="pi pi-star text-muted-color"></i>
                    }
                </td>
                <td>
                    @if (item.Template.MinEntryFee != null) { {{
                    item.Template.MinEntryFee }} } @else {
                    <span class="text-muted-color">—</span>
                    }
                </td>
                <td>
                    @if (canManage()) {
                    <div class="flex items-center gap-2">
                        <p-button
                            icon="pi pi-pencil"
                            severity="warn"
                            [rounded]="true"
                            [outlined]="true"
                            pTooltip="Edit"
                            (onClick)="openEdit(item)"
                        />
                    </div>
                    }
                </td>
            </tr>
        </ng-template>
        <ng-template #emptymessage>
            <tr>
                <td colspan="9" class="text-center py-8 text-muted-color">
                    No game templates yet.
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<app-template-edit-dialog
    [visible]="dialogVisible()"
    (visibleChange)="dialogVisible.set($event)"
    [template]="editingTemplate()"
/>
